
class HeaderNotificationController {
    constructor($window, shopperService, analyticsService, orderManagementService, settings) {
        this.$window = $window;
        this.shopperService = shopperService;
        this.analyticsService = analyticsService;
        this.orderManagementService = orderManagementService;
        this.settings = settings;

        this.isCancelDisabled = false;
    }

    $onInit() {
        this.setNotificationTitlesAndMessages();
        if (!this.shopperService.IsGuest) {
            this.orderManagementService.getOrderBeingAmended();
        }
    }

    cancelChanges() {
        if (!this.isCancelDisabled) {
            this.isCancelDisabled = true;
            const orderBeingAmendedId = this.orderManagementService.orderBeingAmendedId;
            this.orderManagementService.changeOrder(orderBeingAmendedId, true).then(() => {
                this.$window.location.href = `/shop/myaccount/myorders/${orderBeingAmendedId}?amendReverted=1`;
            }).finally(() => {
                this.isCancelDisabled = false;
            });
        }
    }

    get shouldShowAmendingNotification() {
        return this.orderManagementService.orderBeingAmendedId;
    }

    get shouldShowReachedCutoffNotification() {
        return this.orderManagementService.orderReachedAmendCutoffTime;
    }


    setNotificationTitlesAndMessages() {
        this.amendingNotificationTitle = this.settings.orderManagement.amendingNotificationBannerTitle;
        this.cutoffNotificationTitle = this.settings.orderManagement.cutoffNotificationBannerTitle;
        this.cutoffNotificationMessage = this.settings.orderManagement.cutoffNotificationBannerMessage;
    }

    get amendingNotificationMessage() {
        if (!this.orderManagementService.amendCutoffTime) return '';
        const formattedCutOffTime = this.getFormattedCutOffTime(this.orderManagementService.amendCutoffTime);
        const message = this.settings.orderManagement.amendingNotificationBannerMessage;
        return message.replace('{0}', formattedCutOffTime);
    }


    getFormattedCutOffTime(cutOffDateTime) {
        const hour = cutOffDateTime.toLocaleString('en-AU', this.getHourOptions(cutOffDateTime));
        const weekday = cutOffDateTime.toLocaleString('en-AU', { weekday: 'long' });
        const date = cutOffDateTime.getDate();
        const month = cutOffDateTime.toLocaleString('en-AU', { month: 'long' });

        return `${hour}, ${weekday} ${date} ${month}`;
    }

    getHourOptions(date) {
        if (date.getMinutes() > 0) {
            return { hour: 'numeric', minute: 'numeric', hour12: true };
        }
        return { hour: 'numeric', hour12: true };
    }
}

const headerNotificationComponentDefinition = {
    controller: [
        '$window',
        'ShopperService',
        'AnalyticsService',
        'OrderManagementService',
        'Settings',
        HeaderNotificationController,
    ],
    template: require('./header-notification.component.html').trim(),
};

module.exports = {
    HeaderNotificationController,
    headerNotificationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/header-notification/header-notification.component.js